<div class="gjs" *ngIf="jobData.getJob?.jobId != null">

  <!-- ===================== APPLY CARD ===================== -->
  <div class="gjs-apply-card">
    <p class="gjs-rate">{{ rateAmount || '—' }}<span *ngIf="ratePeriodLabel">{{ ratePeriodLabel }}</span></p>
    <p class="gjs-rate-label" *ngIf="subLine">{{ subLine }}</p>

    <a class="gjs-apply-cta"
       [class.gjs-disabled]="!jobData.getJob?.availability || jobData.getJob?.status != 'ACTIVE'"
       target="_blank" rel="noopener noreferrer" href="{{ getLoginParams(jobData.getJob) }}">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>
      Apply Now
    </a>

    <div class="gjs-secondary">
      <button type="button" class="gjs-sec-btn" (click)="onSave()" aria-label="Save this job">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg>
        Save Job
      </button>
      <button type="button" class="gjs-sec-btn" (click)="onShare()" aria-label="Share this job">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" /></svg>
        Share
      </button>
    </div>

    <hr class="gjs-divider" aria-hidden="true">

    <dl class="gjs-meta">
      <div class="gjs-meta-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
        <dd>Posted {{ jobData.getJob?.updatedOn | date:'longDate' }}</dd>
      </div>
      <div class="gjs-meta-item">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
        <dd>{{ jobData.getJob?.viewedByCount || 0 }} {{ (jobData.getJob?.viewedByCount || 0) > 1 ? 'views' : 'view' }}</dd>
      </div>
      <!-- Applicants — wired to backend `applicantsCount` (jobs only). When the
           backend reports 0 or omits the field, show a friendly empty-state
           message rather than "0 applicants". -->
      <div class="gjs-meta-item" [class.gjs-placeholder]="!jobData.getJob?.applicantsCount">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /></svg>
        <dd *ngIf="jobData.getJob?.applicantsCount; else noApplicants">
          {{ jobData.getJob?.applicantsCount }} applicant<span *ngIf="jobData.getJob?.applicantsCount !== 1">s</span> so far
        </dd>
        <ng-template #noApplicants><dd>No applicants so far</dd></ng-template>
      </div>
    </dl>
  </div>

  <!-- ===================== COMPANY / RECRUITER CARD ===================== -->
  <!-- Whole card hidden when there's neither a business nor a recruiter to show — -->
  <!-- the "Join Gigsumo" pitch is context for those rows, not standalone copy.    -->
  <div class="gjs-company-card" *ngIf="jobData.getJob?.jobPostedBehalfOf || getRecruiterName()">
    <div class="gjs-rc-header" *ngIf="jobData.getJob?.jobPostedBehalfOf">
      <div class="gjs-rc-logo" aria-hidden="true">{{ getCompanyInitials() }}</div>
      <div>
        <p class="gjs-rc-name">{{ jobData.getJob?.jobPostedBehalfOf }}</p>
        <p class="gjs-rc-sub" *ngIf="companySub">{{ companySub }}</p>
      </div>
    </div>

    <div class="gjs-rc-person" *ngIf="getRecruiterName()">
      <div class="gjs-rc-av" aria-hidden="true">{{ getRecruiterInitials() }}</div>
      <div>
        <p class="gjs-rc-person-name">{{ getRecruiterName() }}</p>
        <p class="gjs-rc-person-title" *ngIf="recruiterTitle">{{ recruiterTitle }}</p>
      </div>
    </div>

    <p class="gjs-pitch"><strong>Join Gigsumo free</strong> — connect with <ng-container *ngIf="getRecruiterFirstName() as recFirst">{{ recFirst }} and </ng-container>2,000+ tech recruiters posting similar roles daily.</p>
  </div>

  <!-- ===================== SIMILAR JOBS ===================== -->
  <!-- Shown once a fetch has started/finished: loading row, the list, or a -->
  <!-- "couldn't find" message when the search (title -> primary -> secondary) is dry. -->
  <div class="gjs-similar-card" *ngIf="loadingSimilar || hasSearched">
    <p class="gjs-similar-title">Similar Jobs</p>

    <div class="gjs-similar-empty" *ngIf="loadingSimilar">Loading similar jobs…</div>

    <nav *ngIf="!loadingSimilar && similarJobs.length" aria-label="Similar job listings">
      <a *ngFor="let job of similarJobs; let i = index"
         class="gjs-similar-job"
         [routerLink]="['/jobs', similarRoute(job)]"
         (click)="onSelectSimilar(job)">
        <div class="gjs-sj-av" [style.background]="similarColor(i)" aria-hidden="true">{{ similarInitials(job) }}</div>
        <div>
          <!-- Titles are truncated to a single line, so expose the full text on hover -->
          <p class="gjs-sj-name" [title]="job.jobTitle">{{ job.jobTitle }}</p>
          <p class="gjs-sj-meta" *ngIf="similarMeta(job)" [title]="similarMeta(job)">{{ similarMeta(job) }}</p>
        </div>
      </a>
    </nav>

    <div class="gjs-similar-empty" *ngIf="!loadingSimilar && hasSearched && !similarJobs.length">
      Couldn't find any similar jobs.
    </div>
  </div>

</div>
